import NewCandidatesTable from './NewCandidatesTable.container';

export default NewCandidatesTable;
